import config from "../../config/config";
import axios from "axios";
import { getToken } from "../../common";

export const accessSellerAccountAPI = async (userId) => {
  return await axios({
    method: "post",
    url: `${config.api.base_url}dashboard/sellers/${userId}/access-account`,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default accessSellerAccountAPI;
